import PermissionRed from './PermissionRed'
import PermissionGrey from './PermissionGrey'
import VideoPlayPause from './VideoPlayPause'
import AudioPlayMute from './AudioPlayMute'
import EndMeeting from './EndMeeting'
import AudioMuted from './AudioMuted'
import VideoPaused from './VideoPaused'
import RotateVideo from './RotateVideo'

export default {
    PermissionRed,
    PermissionGrey,
    VideoPlayPause,
    AudioPlayMute,
    EndMeeting,
    AudioMuted,
    VideoPaused,
    RotateVideo
}
